import { isNullOrUndefined } from 'util';

export class MessageObject {

    public message: string;

    constructor(message: string) {
        this.message = isNullOrUndefined(message) ? null : message.trim();
    }

    public static create(): MessageObject {
        return new MessageObject(null);
    }
}